import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="progress-bar"
export default class extends Controller {
  static targets = ["bar"];

  connect() {
    document.addEventListener(
      "turbo:before-fetch-request",
      this.show.bind(this)
    );
    document.addEventListener(
      "turbo:before-fetch-response",
      this.hide.bind(this)
    );
  }

  show() {
    this.barTarget.classList.remove("hidden");
    this.barTarget.style.width = "0%";
    this.increment();
  }

  hide() {
    this.barTarget.style.width = "100%";
    setTimeout(() => {
      this.barTarget.classList.add("hidden");
      this.barTarget.style.width = "0%";
    }, 300);
    clearInterval(this.interval);
  }

  increment() {
    let width = 0;
    this.interval = setInterval(() => {
      if (width < 90) {
        width += Math.random() * 10;
        this.barTarget.style.width = width + "%";
      }
    }, 200);
  }
}
